export default {
	footer: {
		'total-received': 'Toplam alınan',
		'paid-total': 'Toplam Ödenen',
		'the-difference': 'Fark'
	},
	previous: 'Önceki',
	next: 'Sonraki'
}